import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Chrome = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.191 11.606 4.74 5.658l-.007-.01a9.995 9.995 0 0 1 15.363.776l.016.012c.449.613.833 1.271 1.145 1.964h-.007a11 11 0 0 0-1.146-1.958l-.005-.003c.45.612.836 1.27 1.15 1.961h-9.157a3.98 3.98 0 0 0-3.9 3.206m3.9 4.806c-1.5 0-2.75-.8-3.45-1.999l-4.585-7.93-.006-.01a10 10 0 0 0 5.871 15.7v-.003l3.468-6.008c-.415.16-.854.244-1.298.25m-2.495-2.331a3 3 0 0 1-.505-1.667 3.01 3.01 0 0 1 3-2.998 3 3 0 1 1-2.495 4.665m12.036-4.654q.203.63.312 1.287v-.002q.145.845.145 1.703c0 4.752-3.317 8.73-7.763 9.745a10 10 0 0 1-1.33.211 10 10 0 0 1-2.021-.011v-.013l4.566-7.93a3.86 3.86 0 0 0 .55-1.998c0-1.2-.55-2.234-1.4-2.992z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.191 11.606 4.74 5.658l-.007-.01a9.995 9.995 0 0 1 15.363.776l.016.012c.449.613.833 1.271 1.145 1.964h-.007a11 11 0 0 0-1.146-1.958l-.005-.003c.45.612.836 1.27 1.15 1.961h-9.157a3.98 3.98 0 0 0-3.9 3.206m3.9 4.806c-1.5 0-2.75-.8-3.45-1.999l-4.585-7.93-.006-.01a10 10 0 0 0 5.871 15.7v-.003l3.468-6.008c-.415.16-.854.244-1.298.25m-2.495-2.331a3 3 0 0 1-.505-1.667 3.01 3.01 0 0 1 3-2.998 3 3 0 1 1-2.495 4.665m12.036-4.654q.203.63.312 1.287v-.002q.145.845.145 1.703c0 4.752-3.317 8.73-7.763 9.745a10 10 0 0 1-1.33.211 10 10 0 0 1-2.021-.011v-.013l4.566-7.93a3.86 3.86 0 0 0 .55-1.998c0-1.2-.55-2.234-1.4-2.992z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
